var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpor = function SvgSpor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#CF6931"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.472 12.992.375-.375a.52.52 0 0 0 0-.736l-.01-.01a.52.52 0 0 0-.736 0l-1.492 1.492L9.137 8.89 10.63 7.4a.52.52 0 0 0 0-.736l-.01-.01a.52.52 0 0 0-.736 0l-.375.375-.376-.375a.526.526 0 0 0-.74 0l-.747.746-.376-.376a.532.532 0 0 0-.746 0 .532.532 0 0 0 0 .746l.376.376-.746.746a.52.52 0 0 0 0 .736l.375.375-.375.381a.52.52 0 0 0 0 .736l.01.01a.52.52 0 0 0 .736 0L8.39 9.637l4.472 4.472L11.37 15.6a.52.52 0 0 0 0 .736l.01.01a.52.52 0 0 0 .736 0l.375-.375.376.375a.52.52 0 0 0 .736 0l.746-.746.376.376a.532.532 0 0 0 .746 0 .532.532 0 0 0 0-.746l-.376-.376.751-.746a.52.52 0 0 0 0-.736l-.375-.38Z",
    fill: "#fff"
  })));
};
export default SvgSpor;